import { ComponentWithPermissions } from '../../../../../../../baseComponents/CreateRoutering/types'
import BaseScreenTable from '../../../../../../../baseComponents/TwinTable/BaseScreenTable'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'
import TableSellTickets from '../../../../../../../specificComponents/sells/TableSellTickets'
import NullComponent from '../../../../../../../baseComponents/NullComponent'

interface SellTicketsProps extends ComponentWithPermissions { }

const SellTickets: React.FC<SellTicketsProps> = ({ userPermissions }) => {
    const { t } = useTwinTranslation()

    const pageData = {
        title: t('tickets', 'Tickets'),
        newText: '',
    }

    return (
        <BaseScreenTable TableComponent={TableSellTickets} CreateModalComponent={NullComponent} pageData={pageData} userPermissions={userPermissions} />
    )
}

export default SellTickets